// src/components/sections/PartnerCarousel.jsx
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

// Import dei loghi
import casillo from "../../assets/partner/casillo.svg";
import deliziosa from "../../assets/partner/deliziosa.png";
import rossogargano from "../../assets/partner/rossogargano.webp";
import contizecca from "../../assets/partner/contizecca.svg";
import birrasalento from "../../assets/partner/birrasalento.png";
import montedirena from "../../assets/partner/montedirena.png";
import hb from "../../assets/partner/hb.svg";

const brands = [
    { src: casillo, alt: "Casillo" },
    { src: deliziosa, alt: "Deliziosa" },
    { src: montedirena, alt: "montedirena" },
    { src: rossogargano, alt: "Rosso Gargano" },
    { src: contizecca, alt: "Conti Zecca" },
    { src: birrasalento, alt: "Birra Salento" },
    { src: hb, alt: "HB" },
];

export default function PartnerCarousel() {
    return (
        <section className="py-20 bg-black text-center">
            <motion.h2
                className="text-3xl md:text-4xl font-title text-primary mb-10 tracking-tight"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                I nostri partner di qualità
            </motion.h2>

            {/* Carosello + Gradienti */}
            <div className="relative w-full max-w-6xl mx-auto px-0 z-10">
                {/* Gradient sinistro (solo mobile) */}
                <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-black/90 to-transparent z-20 pointer-events-none md:hidden" />

                {/* Gradient destro (solo mobile) */}
                <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-black/90 to-transparent z-20 pointer-events-none md:hidden" />

                <Swiper
                    slidesPerView={3}
                    spaceBetween={10}
                    loop={true}
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    breakpoints={{
                        640: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 7 },
                    }}
                    modules={[Autoplay, Pagination]}
                >
                    {brands.map((brand, idx) => (
                        <SwiperSlide key={idx}>
                            <div className="flex items-center justify-center h-full px-2">
                                <motion.img
                                    src={brand.src}
                                    alt={brand.alt}
                                    className="h-20 md:h-24 object-contain grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition duration-300 cursor-pointer mx-auto"
                                    loading="lazy"
                                    whileHover={{ scale: 1.1 }}
                                    draggable={false}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}
